_ = require 'underscore'

module.exports = (text, formatter) ->
  tokens = []
  for block in formatter.blockLex(text, {})
    if block.children?
      tokens = [tokens..., formatter.inlineLex(block.children.text)...]

  results = _.chain(tokens)
  .filter (token) ->
    token.type == 'link'
  .map (token) ->
    text = token.children?.text

    if text?
      url: token.url
      text: formatter.textInline(token.children?.text)
    else
      url: token.url
  .value()

  results
